import { Paper } from "@mantine/core";
import { regionApi } from "apis/regionApi";
import { Loading } from "components";
import { ErrorStatusType } from "constants/types/common";
import { RegionResponse } from "constants/types/region";
import { useFormik } from "formik";
import { FORM_IDS } from "pages/Region/config";
import { FC, useState } from "react";
import { useNotification } from "utils/hooks";
import RegionFormFields from "../RegionFormFields/RegionFormFields";
import { editValidationSchema } from "./config";

interface EditFormProps {
  region: RegionResponse;
  onClose?: () => void;
  mutate?: () => void;
}

const EditForm: FC<EditFormProps> = ({ region, onClose, mutate }) => {
  const { notification } = useNotification();
  const [isLoading, setIsLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      name: region.name,
    },
    validationSchema: editValidationSchema,
    enableReinitialize: true,
    onSubmit: async (values) => {
      setIsLoading(true);
      try {
        const res = await regionApi.update(region.id, values);
        if (res.data.success) {
          notification.success({ title: "Cập nhật địa bàn thành công" });
          onClose?.();
          mutate?.();
        }
      } catch (error: ErrorStatusType | any) {
        notification.error({ title: "Cập nhật địa bàn thất bại", message: error?.error?.message });
      }
      setIsLoading(false);
    },
  });

  return (
    <Loading variant="overlay" visible={isLoading}>
      <Paper>
        <form id={FORM_IDS.EDIT} onSubmit={formik.handleSubmit}>
          <RegionFormFields formik={formik} />
        </form>
      </Paper>
    </Loading>
  );
};

export default EditForm;
